<template>
  <div class="layout">
    <h2 class="title blind">국내외 문화 통계 사이트</h2>
    <div class="notice-detail">
      <div class="notice-detail-header">
        <h3>{{ detailData.boardtitle }}</h3>
      </div>
	  <div class="notice-txt" style="padding: 20px 0; height: 1080px;">
		<iframe :title="detailData.boardtitle" id="statsSiteFrame" :src="detailData.descriptionUrl" style="border: none; width: 100%; height: 100%;"></iframe>
	  </div>
      <div class="notice-prev-next" :orderRowNum="orderRowNum">
        <a v-if="detailData.nextBoardId != null" href="javascript:;" class="next" @click.prevent="boardDetail(detailData.nextBoardId, detailData.boardType, parseInt(orderRowNum) - 1)">
          <span>다음글</span>
          <span>{{ detailData.nextTitle }}</span>
        </a>
        <a v-if="detailData.preBoardId != null" href="javascript:;" class="prev" @click.prevent="boardDetail(detailData.preBoardId, detailData.boardType, parseInt(orderRowNum) + 1)">
          <span>이전글</span>
          <span>{{ detailData.preTitle }}</span>
        </a>
      </div>
    </div>
    <div class="btn-layout center">
      <a class="gray btn" href="javascript:;" @click.prevent="boardList()">목록</a>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/Notice.js'
import * as file from '@/api/common/file.js'
import * as staticApi from '@/api/Statistics.js'

export default {
	name: 'BoardDetailItem',

	data () {
		return {
			target: this.$route.query.target,
			boardId: this.$route.query.boardId,
			boardType: this.$route.query.boardType,
			orderRowNum: this.$route.query.orderRowNum,
			searchText: this.$route.query.searchText,
			codeId: this.$route.query.codeId,
			detailData: [],
			fileList: []
		}
	},

	created () {
		this.searchBoardDetail(this.boardId, this.boardType, this.searchText, this.codeId)
	},

	methods: {
		async searchBoardDetail (boardId, boardType, searchText, codeId) {
			const paramData = {
				boardType: boardType,
				boardId: boardId,
				searchText: searchText,
				stblType: codeId
			}

			await this.updateBoardHits(paramData)

			document.getElementById('statsSiteFrame').src = '';
			const boardData = await api.searchBoardDetail(paramData)
			this.detailData = boardData.data
		},

		// 게시판 상세보기
		boardDetail (boardId, boardType, orderRowNum) {
			// 이전글 다음글 이동시 페이지 변경
			this.orderRowNum = orderRowNum
			if (orderRowNum % 5 == 0) {
				this.$route.query.page = orderRowNum / 5
			} else if (!orderRowNum % 5 == 0) {
				this.$route.query.page = Math.ceil(orderRowNum / 5)
			}

			const paramData = {
				boardId: boardId,
				boardType: boardType
			}

			this.$router.push({ name: this.$route.name, query: Object.assign({}, this.$route.query, paramData) }).catch(error => {
				if (error.name != 'NavigationDuplicated') {
					throw error
				}
			})
		},

		// 게시판 목록으로 가기
		boardList () {
			if (this.target) {
				this.$router.push({ name: this.target, query: Object.assign({}, this.$route.query) }).catch(() => {
					this.$router.go(-1)
				})
			} else {
				this.$router.go(-1)
			}
		},

		// 게시판 히트수 업데이트
		async updateBoardHits (paramData) {
			await api.updateBoardHits(paramData)
		}
	},

	watch: {
		$route (to, from) {
			if (to.path == from.path) {
				this.boardId = this.$route.query.boardId
				this.boardType = this.$route.query.boardType
				this.searchText = this.$route.query.searchText
				this.codeId = this.$route.query.codeId
			}
			this.searchBoardDetail(this.boardId, this.boardType, this.searchText, this.codeId)
		}
	}
}
</script>
<style scoped>
.align-start {
  display: flex !important;
  justify-content: flex-start !important;
}

/* file-viewer */
.file-viewer {
  width: 91px;
  height: 31px;
  background-image: url("../assets/img/ico_preview_detail.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.file-viewer:hover {
  background-image: url("../assets/img/ico_preview_detail_hover.png");
}
</style>
